import { render, staticRenderFns } from "./Details.vue.js?vue&type=template&id=44c43cca&scoped=true!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=template&id=44c43cca&scoped=true"
import script from "./Details.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=script&lang=js"
export * from "./Details.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=script&lang=js"
import style0 from "./Details.vue.scss?vue&type=style&index=0&id=44c43cca&prod&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=style&index=0&id=44c43cca&prod&scoped=true&lang=scss"
import style1 from "./Details.vue.scss?vue&type=style&index=1&id=44c43cca&prod&lang=scss!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Details.vue?vue&type=style&index=1&id=44c43cca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c43cca",
  null
  
)

export default component.exports